/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Section_Exceptions_TitleInputs */

const en_ticket_section_exceptions_title = /** @type {(inputs: Ticket_Section_Exceptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report a problem`)
};

const ja_ticket_section_exceptions_title = /** @type {(inputs: Ticket_Section_Exceptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題を報告`)
};

const fr_ticket_section_exceptions_title = /** @type {(inputs: Ticket_Section_Exceptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaler un problème`)
};

const de_ticket_section_exceptions_title = /** @type {(inputs: Ticket_Section_Exceptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem melden`)
};

/**
* | output |
* | --- |
* | "Report a problem" |
*
* @param {Ticket_Section_Exceptions_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_section_exceptions_title = /** @type {((inputs?: Ticket_Section_Exceptions_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Section_Exceptions_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_section_exceptions_title(inputs)
	if (locale === "ja") return ja_ticket_section_exceptions_title(inputs)
	if (locale === "fr") return fr_ticket_section_exceptions_title(inputs)
	return de_ticket_section_exceptions_title(inputs)
});